import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommercePublicKeyEntityState} from "../reducers/ecommerce-public-key.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommercePublicKeyState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommercePublicKey.entities[websiteId]);

export const getEcommercePublicKey = (websiteId: number) => createSelector(getEcommercePublicKeyState(websiteId),
  (state: IEcommercePublicKeyEntityState) => {
    return state?.data || [];
  }
);

export const getEcommercePublicKeyLoading = (websiteId: number) => createSelector(getEcommercePublicKeyState(websiteId),
  (state: IEcommercePublicKeyEntityState) => state && state.loading
);

export const getEcommercePublicKeyLoaded = (websiteId: number) => createSelector(getEcommercePublicKeyState(websiteId),
  (state: IEcommercePublicKeyEntityState) => state && state.loaded
);
